module.exports = __webpack_public_path__ + "media/images/icons/tiktok_circle-52f44455360eaa9405e7757bc51007a9.svg";